'use client';
import { CatButton } from 'components/blocks-components-interactive';
import { useTranslations } from 'next-intl';

interface ViewDiagramButtonProps {
  onClick?: () => void;
  isDisabled?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  dataTestId?: string;
}

const ViewDiagramButton = ({
  onClick,
  isDisabled = false,
  className = '',
  size = 'md',
  dataTestId = 'view-diagram-button'
}: ViewDiagramButtonProps) => {
  const t = useTranslations();

  return (
    <CatButton
      data-testid={dataTestId}
      size={size}
      className={className}
      disabled={isDisabled}
      onClick={onClick}
    >
      {t('SSO_VIEW_DIAGRAM')}
    </CatButton>
  );
};

export default ViewDiagramButton;
